import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';

interface IPlanTooltipProps {
    planIndex: number;
    index: number;
    title: string;
    info: string;
    text: string;
};

export default function PlanTooltip (props: IPlanTooltipProps) {
    const { planIndex, index, title, info, text } = props;

    return (
        <div className="single-card-plan-tooltip d-flex justify-content-between align-items-center align-content-center">
            <div className="tooltip-namespace-info d-flex">
                <img
                    src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Tooltip.svg"
                    id={"single-tooltip-" + planIndex + "-" + index}
                    alt=""
                />
                <UncontrolledTooltip placement="top-start" innerClassName="custom-tooltip" target={"single-tooltip-" + planIndex + "-" + index}>
                    {text}
                </UncontrolledTooltip>
                <p className="p-0 m-0 px-14">{title}</p>
            </div>
            <span className="px-14 m-0 p-0">{info}</span>
        </div>
    );
}